import { request } from '../utils/request';
import {
  ReportDocument,
  GetSystemUserDocument,
  GetAppConfigDocument,
  GetReportByPathDocument,
  GetReportByActionDocument,
  GetReportByActionFunnelDocument,
  GetPathListDocument,
  GetActionListDocument,
} from './operations';
import { print } from 'graphql';

export const VISUALIZATION_API_HOST = 'agency.woa.com';
const REPORT_API_BASE_PATH = 'https://e.qq.com/data-report-hub/api'; // '/data-report-hub/api';
const VISUALIZATION_API_BASE_PATH = `https://${VISUALIZATION_API_HOST}/data-report-hub/api`;

const getParams = (doc: any, variables?: any) => ({
  query: print(doc),
  variables: variables || {},
});

// 事件上报
export const report = (variables: any) => request.post(REPORT_API_BASE_PATH, getParams(ReportDocument, variables));
export const reportSendBeacon = (variables: any) => {
  const body = getParams(ReportDocument, variables);
  const headers = {
    type: 'application/json',
  };
  const blob = new Blob([JSON.stringify(body)], headers);
  return navigator.sendBeacon(REPORT_API_BASE_PATH, blob);
};

// 获取系统用户信息
export const getSystemUser = () => request.post(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetSystemUserDocument),
);
// 获取系统配置
export const getAppConfig = () => request.post(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetAppConfigDocument),
);
// 获取页面埋点数据
export const getReportByPath = (variables: any) => request.post(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetReportByPathDocument, variables),
);
// 获取单个埋点详细数据
export const getReportByAction = (variables: any) => request.post(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetReportByActionDocument, variables),
);
// 获取漏斗数据
export const getReportByActionFunnel = (variables: any) => request.post(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetReportByActionFunnelDocument, variables),
);

// 获取路径列表
export const getPathList = (variables: any) => request.post(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetPathListDocument, variables),
);

// 获取事件列表
export const getActionList = (variables: any) => request.post(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetActionListDocument, variables),
);
